import { useState, useEffect } from 'react';

export default function CookieNotice() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        localStorage.getItem('cookie-consent') !== 'true' && setIsVisible(true);
        const handleStorageChange = (event: StorageEvent) => {
            if (event.key === 'cookie-consent' && event.newValue === 'true') {
                setIsVisible(false);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    const handleGotIt = () => {
        setIsVisible(false);
        localStorage.setItem('cookie-consent', 'true');
    };
 

    return (
        <div
            style={{
                position: 'fixed',
                bottom: '20px',
                left: '20px',
                right: '20px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '16px',
                padding: '20px 24px',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.1) inset',
                zIndex: 1000,
                maxWidth: '800px',
                margin: '0 auto',
                transform: isVisible ? 'translateY(0)' : 'translateY(100%)',
                opacity: isVisible ? 1 : 0,
                transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
                animation: isVisible ? 'slideUp 0.6s ease-out' : 'none'
            }}
        >
            <style>{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>

            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                <div style={{
                    fontSize: '24px',
                    minWidth: '24px',
                    marginTop: '2px'
                }}>
                    🍪
                </div>

                <div style={{ flex: 1 }}>
                    <h3 style={{
                        color: 'white',
                        fontSize: '16px',
                        fontWeight: '600',
                        margin: '0 0 8px 0',
                        lineHeight: '1.4'
                    }}>
                        Çerezler Hakkında Bilgi
                    </h3>

                    <p style={{
                        color: 'rgba(255, 255, 255, 0.9)',
                        fontSize: '14px',
                        lineHeight: '1.5',
                        margin: '0 0 16px 0'
                    }}>
                        Sitemizi kullanarak deneyiminizi iyileştirmek için çerezleri kullandığımızı kabul etmiş olursunuz.
                        Siteyi kullanmaya devam ederek bu uygulamayı onaylamış sayılırsınız.
                    </p>

                    <button
                        onClick={handleGotIt}
                        style={{
                            background: 'rgba(255, 255, 255, 0.2)',
                            border: '1px solid rgba(255, 255, 255, 0.3)',
                            borderRadius: '8px',
                            color: 'white',
                            padding: '8px 16px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            backdropFilter: 'blur(4px)'
                        }}
                        onMouseEnter={(e) => {
                            //@ts-ignore
                            e.target.style.background = 'rgba(255, 255, 255, 0.3)';
                            //@ts-ignore
                            e.target.style.transform = 'translateY(-1px)';
                        }}
                        onMouseLeave={(e) => {
                            //@ts-ignore
                            e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                            //@ts-ignore
                            e.target.style.transform = 'translateY(0)';
                        }}
                    >
                        Anladım
                    </button>
                </div>

                <button
                    onClick={handleGotIt}
                    style={{
                        background: 'transparent',
                        border: 'none',
                        color: 'rgba(255, 255, 255, 0.7)',
                        fontSize: '20px',
                        cursor: 'pointer',
                        padding: '4px',
                        borderRadius: '4px',
                        transition: 'all 0.2s ease',
                        lineHeight: '1'
                    }}
                    onMouseEnter={(e) => {
                        //@ts-ignore
                        e.target.style.color = 'white';
                        //@ts-ignore
                        e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                        //@ts-ignore
                        e.target.style.color = 'rgba(255, 255, 255, 0.7)';
                        //@ts-ignore
                        e.target.style.background = 'transparent';
                    }}
                >
                    ×
                </button>
            </div>
        </div>
    );
}